import { render, staticRenderFns } from "./AttributesDisplay.vue?vue&type=template&id=34c0923a&scoped=true"
import script from "./AttributesDisplay.vue?vue&type=script&lang=js"
export * from "./AttributesDisplay.vue?vue&type=script&lang=js"
import style0 from "./AttributesDisplay.vue?vue&type=style&index=0&id=34c0923a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c0923a",
  null
  
)

export default component.exports